<template>
  <div id="app">
    <keep-alive>
      <router-view class="view-router" v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    </keep-alive>
    <router-view class="view-router" v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    <router-view name="tabbar"></router-view>
    <!-- <div v-if="!$route.meta.hideMenu"> -->
    <div v-if="false">
      <div class="float-menu-mask" v-if="showMenu" @click="showMenu = !showMenu"></div>
      <drag>
        <div class="float-menu" v-if="!showMenu" @click="showMenu = !showMenu">
          <van-row type="flex" align="center" justify="space-around">
            <!-- <van-col span="12" class="menu-left-arrow-wrap">
            <img class="img" src="./assets/images/menu-left-arrow.png" alt="">
            </van-col>-->
            <van-col span="12" class="menu-right-text-wrap">
              <van-icon name="daohang" />
              <!-- <div class="menu-name">导航</div> -->
            </van-col>
          </van-row>
        </div>
      </drag>
      <div class="float-right-menu-wrap" v-show="showMenu">
        <van-popup v-model="showMenu" position="right" :overlay="false">
          <div class="float-menu-top">
            <van-icon name="kuaisu" />
            <span>快速通道</span>
          </div>
          <div class="float-menu-content">
            <van-row align="center" justify="space-around">
              <van-col class="border-bottom" span="8">
                <div class="col" @click="gotoOrder">
                  <van-icon name="tubiao215" />
                  <div class="text">我的订单</div>
                </div>
              </van-col>
              <van-col class="border-bottom" span="8">
                <div class="col" @click="gotoCart">
                  <van-icon name="baoguo-kongxin" />
                  <div class="text">购物车</div>
                </div>
              </van-col>
              <van-col class="border-bottom" span="8">
                <div class="col" @click="gotoAddress">
                  <van-icon name="ditu1" />
                  <div class="text">我的地址</div>
                </div>
              </van-col>
              <van-col span="8">
                <div class="col" @click="gotoPersonnal">
                  <van-icon name="username" />
                  <div class="text">个人中心</div>
                </div>
              </van-col>
              <van-col span="8">
                <div class="col" @click="gotoCategory">
                  <van-icon name="fail" />
                  <div class="text">商品分类</div>
                </div>
              </van-col>
              <van-col span="8">
                <div class="col" @click="gotoCustomService">
                  <van-icon name="kefu" />
                  <div class="text">联系客服</div>
                </div>
              </van-col>
            </van-row>
          </div>
          <div class="float-menu-bottom" @click="gotoHome">
            <span>返回商城首页</span>
          </div>
        </van-popup>
      </div>
    </div>
  </div>
</template>

<script>
import drag from "./vue/components/drag/index.vue";
export default {
  data() {
    return {
      showMenu: false
    };
  },
  components: {
    drag
  },
  mounted() {
  },
  methods: {
    gotoHome() {
      this.showMenu = false;
      this.$router.push({
        name: "home"
      });
    },
    gotoOrder() {
      this.showMenu = false;
      this.$router.push({
        name: "user-order-list",
        params: {
          active: 0
        }
      });
    },
    gotoCart() {
      this.showMenu = false;
      this.$router.push({
        name: "cart"
      });
    },
    gotoCategory() {
      this.showMenu = false;
      this.$router.push({
        name: "class"
      });
    },
    gotoPersonnal() {
      this.showMenu = false;
      this.$router.push({
        name: "user"
      });
    },
    gotoAddress() {
      this.showMenu = false;
      this.$router.push({
        name: "address"
      });
    },
    gotoCustomService() {
      this.showMenu = false;
      this.$router.push({
        name: "user-server"
      });
    }
  }
};
</script>

<style lang="scss" src="./assets/scss/global.scss" />
